class SupplementsBuilder extends HTMLElement {
  constructor() {
    super();

    this.productForms = document.querySelectorAll('[action="/cart/add"]');
    this.productIdInputs = document.querySelectorAll('[action="/cart/add"] [name="id"]');
    this.packSection = document.querySelector(".supplements-builder-packs-section");
    this.sportSection = document.querySelector(".supplements-builder-sports-section");
    this.sportSectionSelect = this.sportSection.querySelector("select");
    this.trainingSection = document.querySelector(".supplements-builder-training-section");
    this.rationSection = document.querySelector(".supplements-builder-ration-section");
    this.rationSectionRations = this.rationSection.querySelectorAll("[maximum-units-per-package]");
    // this.chooseSection = document.querySelector('.supplements-builder-choose-section');
    this.addToCartButton = document.querySelector('[action*="/cart/add"] [type*="submit"]');
    this.addToCartButtonInjecter = this.addToCartButton.querySelector("buy-buttons button > div");
    this.activePack = document.querySelector('[name="radio-packs"][checked]');
    this.packs = document.querySelectorAll('[name="radio-packs"]');
    this.playButtons = this.querySelectorAll(".supplements-builder-explanation-media-play-button");
    this.dialogs = this.querySelectorAll("dialog");
    this.config = {
      combinedProduct: true,
      pack: null,
      packPrice: null,
      sports: null,
      training: null,
      ration: null,
      choose: null,
      chooseValues: null,
    };
    this.currencyFormatter = new Intl.NumberFormat(Shopify.locale, {
      style: "currency",
      currency: Shopify.currency.active,
    });
    this.originalAddToCartText = this.addToCartButtonInjecter.innerHTML;

    console.log(
      "\r\n    ____        _ __    __             __             ____        __    ____          __           \r\n   / __ )__  __(_) /___/ /__  _____   / /_  __  __   / __ )____ _/ /___/ / /_  __  __/ /____  _____\r\n  / __  / / / / / / __  / _ \\/ ___/  / __ \\/ / / /  / __  / __ `/ / __  / __ \\/ / / / __/ _ \\/ ___/\r\n / /_/ / /_/ / / / /_/ /  __/ /     / /_/ / /_/ /  / /_/ / /_/ / / /_/ / /_/ / /_/ / /_/  __(__  ) \r\n/_____/\\__,_/_/_/\\__,_/\\___/_/     /_.___/\\__, /  /_____/\\__,_/_/\\__,_/_.___/\\__, /\\__/\\___/____/  \r\n                                         /____/                             /____/                 \r\n"
    );
    this.eventListener();
    this.addToCartToggle();
    this.packSelector(this.activePack);
    this.removeProductIds();
  }

  updateSections() {
    this.config.pack ? this.toggleSection(this.sportSection, true) : this.toggleSection(this.sportSection, false);
    this.config.pack && this.config.sports
      ? this.toggleSection(this.trainingSection, true)
      : this.toggleSection(this.trainingSection, false);
    this.config.pack && this.config.sports && this.config.training && this.config.combinedProduct
      ? this.toggleSection(this.rationSection, true)
      : this.toggleSection(this.rationSection, false);
    // this.config.pack && this.config.sports && this.config.training && this.config.ration ? this.toggleSection(this.chooseSection, true) : this.toggleSection(this.chooseSection, false);
    this.addToCartToggle();
  }

  customEvent(element, eventName) {
    element.dispatchEvent(
      new CustomEvent(eventName, {
        bubbles: true,
      })
    );
  }

  addToCartToggle() {
    if (!this.config.pack || !this.config.sports || !this.config.training || !this.config.ration) {
      this.addToCartButton.disabled = true;
      this.addToCartButton.classList.add("button--subdued");
    } else {
      this.addToCartButton.removeAttribute("disabled");
      this.addToCartButton.classList.remove("button--subdued");
    }
  }

  toggleSection(section, value) {
    section.setAttribute("aria-disabled", !value);
  }

  packSelector(pack) {
    this.config.pack = pack.value;
    this.config.packPrice = Number(pack.getAttribute("price"));
    if (pack.value === this.packs[0].value) {
      this.config.combinedProduct = true;
    } else {
      this.config.combinedProduct = false;
    }
    this.customEvent(pack, "builder:config:updated");
  }

  sportsSelector(e) {
    this.config.sports = e.target.value;
    this.customEvent(e.target, "builder:config:updated");
  }

  handlePackClick(pack) {
    if (pack.checked) this.packSelector(pack);
  }

  removeProductIds() {
    for (const productIdInput of this.productIdInputs) {
      productIdInput.remove();
    }
  }

  increaseTraining() {
    const element = this.trainingSection.querySelector("#training-quantity");
    element.value = Number(element.value) + 1;
    this.config.training = Number(element.value);
    this.customEvent(element, "builder:config:updated");
  }

  decreaseTraining() {
    const element = this.trainingSection.querySelector("#training-quantity");
    if (element.value > Number(element.min)) {
      element.value = Number(element.value) - 1;
      this.config.training = Number(element.value);
      this.customEvent(element, "builder:config:updated");
    }
  }

  changeTraining() {
    if (this.config.sports) {
      this.config.training = Number(this.trainingSection.querySelector("#training-quantity").value);
      this.customEvent(this.trainingSection, "builder:config:updated");
    }
  }

  updateTraining() {
    if (this.config.sports && !this.config.training) {
      this.config.training = Number(this.trainingSection.querySelector("#training-quantity").value);
      this.config.ration = [];
      this.customEvent(this.trainingSection, "builder:config:updated");
    }
  }

  updateRation() {
    if (this.config.training) {
      for (const ration of this.rationSectionRations) {
        const maximumUnitsPerPackage = Number(ration.getAttribute("maximum-units-per-package"));
        if (maximumUnitsPerPackage) {
          const rationResult = Math.ceil((this.config.training * 4) / maximumUnitsPerPackage);
          const newRation = [
            ...this.config.ration.filter((config) => config.id !== Number(ration.getAttribute("product-id"))),
            {
              id: Number(ration.getAttribute("product-id")),
              value: rationResult,
              granulat: ration.hasAttribute("is-granulat"),
              price: Number(ration.getAttribute("price")) * rationResult,
              displayValue: rationResult * maximumUnitsPerPackage
            },
          ];
          // this.chooseSection.querySelector(`[product-id="${ration.getAttribute("product-id")}"]#choose-quantity`).value = rationResult
          this.config.ration = newRation;
          ration.innerHTML = rationResult * maximumUnitsPerPackage;
        }
      }
    }
  }

  updateProductForm() {
    console.log(this.config.ration);
    let price = 0;
    const combinedProduct = document.querySelector("[is-combined-product]");
    const granulat = this.config.ration?.find((item) => item.granulat);
    const products = this.config.ration?.filter((item) => !item.granulat);

    let isFullPath = true;

    products?.forEach((item) => {
      if (granulat && item.value !== granulat?.value) {
        isFullPath = false;
      }
    });

    let html = ``;

    if (isFullPath && this.config.combinedProduct && combinedProduct) {
      price = price + Number(combinedProduct.getAttribute("price")) * granulat.value;
      html = `
        <input supplements-builder name="items[0][id]" value="${combinedProduct.value}" type="hidden"></input>
        <input supplements-builder name="items[0][quantity]" value="${granulat.value}" type="hidden"></input>
      `;
    } else if (this.config.combinedProduct && combinedProduct) {
      price = price + Number(combinedProduct.getAttribute("price")) * granulat.value;
      html = `
        <input supplements-builder name="items[0][id]" value="${combinedProduct.value}" type="hidden"></input>
        <input supplements-builder name="items[0][quantity]" value="${granulat.value}" type="hidden"></input>
        ${
          products
            ? products.map((item, index) => {
                price = price + (item.price / item.value) * (item.value - granulat.value);
                return `
            <input supplements-builder name="items[${index + 1}][id]" value="${item.id}" type="hidden"></input>
            <input supplements-builder name="items[${index + 1}][quantity]" value="${
                  item.value > 1 ? item.value - granulat.value : item.value
                }" type="hidden"></input>
            `;
              })
            : ""
        }
      `;
    } else if (!granulat) {
      html = `
        ${
          products
            ? products.map((item, index) => {
                price = price + (item.price / item.value) * (item.value - 0);
                return `
            <input supplements-builder name="items[${index + 1}][id]" value="${item.id}" type="hidden"></input>
            <input supplements-builder name="items[${index + 1}][quantity]" value="${
                  item.value > 1 ? item.value - 0 : item.value
                }" type="hidden"></input>
            `;
              })
            : ""
        }
      `;
    } else {
      price = price + this.config.packPrice * this.config.training;
      html = `
      <input supplements-builder name="items[0][id]" value="${this.config.pack}" type="hidden"></input>
      <input supplements-builder name="items[0][quantity]" value="${this.config.training}" type="hidden"></input>
    `;
    }

    this.addToCartButtonInjecter.innerHTML = `${this.originalAddToCartText} - ${this.currencyFormatter.format(
      price / 100
    )}`;

    for (const productForm of this.productForms) {
      const allInputs = productForm.querySelectorAll("[supplements-builder]");
      for (const input of allInputs) {
        input.remove();
      }
    }

    for (const productForm of this.productForms) {
      productForm.insertAdjacentHTML("beforeend", html);
    }
  }

  hideOrDisplaySections() {
    if (this.config.combinedProduct) {
      this.rationSection.style.display = "grid";
      // this.chooseSection.style.display = "grid";
    } else {
      this.rationSection.style.display = "none";
      // this.chooseSection.style.display = "none";
    }
  }

  handleDialog(playButton) {
    const dialog = playButton.parentElement.querySelector("dialog");
    if (dialog) dialog.showModal();
  }

  handleDialogChange(dialog) {
    const video = dialog.querySelector("video");
    if (video) video.pause();
  }

  eventListener() {
    this.sportSectionSelect.addEventListener("change", this.sportsSelector.bind(this));
    this.trainingSection.querySelector("#training-quantity").addEventListener("change", this.changeTraining.bind(this));
    this.trainingSection.querySelector("#training-quantity").addEventListener("input", this.changeTraining.bind(this));
    this.trainingSection
      .querySelector(".training-quantity-plus")
      .addEventListener("click", this.increaseTraining.bind(this));
    this.trainingSection
      .querySelector(".training-quantity-minus")
      .addEventListener("click", this.decreaseTraining.bind(this));
    this.addEventListener("builder:config:updated", this.updateSections.bind(this));
    this.addEventListener("builder:config:updated", this.updateTraining.bind(this));
    this.addEventListener("builder:config:updated", this.updateRation.bind(this));
    this.addEventListener("builder:config:updated", this.hideOrDisplaySections.bind(this));
    this.addEventListener("builder:config:updated", this.updateProductForm.bind(this));

    for (const pack of this.packs) {
      pack.addEventListener("click", this.handlePackClick.bind(this, pack));
    }

    for (const playButton of this.playButtons) {
      playButton.addEventListener("click", this.handleDialog.bind(this, playButton));
    }

    for (const dialog of this.dialogs) {
      dialog.addEventListener("close", this.handleDialogChange.bind(this, dialog));
    }
  }
}

customElements.define("supplements-builder", SupplementsBuilder);
